import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { SkeletonModule } from 'primeng/skeleton'
import { ButtonModule } from 'primeng/button'
import { TooltipModule } from 'primeng/tooltip'
import { SkeletonPreloaderListComponent } from '../../components/skeleton-preloader-list-component/skeleton.preloader.list.component'
import { SkeletonPreloaderTileComponent } from '../../components/skeleton-preloader-list-component/skeleton-preloader-tile-component/skeleton.preloader.tile.component'
import { IconActionButton } from '../../components/icon-action-button/icon.action.button'

@NgModule({
  declarations: [SkeletonPreloaderListComponent, SkeletonPreloaderTileComponent, IconActionButton],
  exports: [SkeletonPreloaderListComponent, SkeletonPreloaderTileComponent, IconActionButton],
  imports: [CommonModule, FormsModule, RouterModule, SkeletonModule, ButtonModule, TooltipModule]
})
export class SharedComponentsModule {}
